import { IHttpClient } from "@evergis/api";

export class Service {
  constructor(protected http: IHttpClient) {}
}
